import {
  Component, Input, Output, EventEmitter, OnInit, DoCheck, OnChanges, SimpleChanges
} from '@angular/core';
import {TabularColumn} from './tabular';
import {ITabularConfig} from './tabular-config.interface';
import {ActionConfigRouteType, IActionsConfig} from './actions-config.interface';
import {TabularSortByService, SortByDirection, ISortByProperty} from './tabular-sort-by.service';
import {TabularConfig} from './tabular.config';
import {TabularSize} from './tabular-size.enum';
import {ITabularColumnBadgeType, ITabularColumnIconType, TabularColumnTypes} from './tabular-column.interface';
import {ITabularRow} from './tabular-row.interface';
import {Context} from '../enums';
import * as _ from 'lodash';

@Component({
  selector: 'hxa-tabular',
  template: `<table class="tabular hx-table is-striped" [class.is-hover]="config.clickableRows" [class.is-narrow]="config.size === TabularSize.Small">
  <thead>
  <tr>
    <th *ngFor="let col of columns" class="{{col.cssClass}} tabular__{{col.label}}" [ngClass]="{'tabular__checkboxes': col.dataType === TabularColumnTypes.Checkbox, 'tabular__sortable': col.sortable}">

      <!-- sortable column -->
      <a class="tabular__sorter" href="#" *ngIf="col.sortable && col.dataType != TabularColumnTypes.Checkbox" (click)="onSortClickHandler(col.id, col.dataType)">{{col.label}} <i class="hx-icon icon-arrow-up is-small" [class.icon-arrow-up]="isColumnSorted(col.id, SortByDirection.Ascending)" [class.icon-arrow-down]="isColumnSorted(col.id, SortByDirection.Descending)" *ngIf="isColumnSorted(col.id, SortByDirection.Descending) || isColumnSorted(col.id, SortByDirection.Ascending)"></i></a>

      <!-- non sortable column -->
      <span *ngIf="!col.sortable && col.dataType !== TabularColumnTypes.Checkbox">{{col.label}}</span>

      <!-- checkbox column -->
      <div *ngIf="col.dataType === TabularColumnTypes.Checkbox" class="hx-checkbox-control">
        <input id="selectAll" name="selectAll" type="checkbox" class="hx-checkbox" (change)="toggleSelectAll($event)" title="Select All" [(ngModel)]="selectAll" />
        <label for="selectAll" class="hx-label"></label>
      </div>
    </th>
  </tr>
  </thead>

  <tbody>
  <!--<tr *ngFor="let row of rows | paginate: config.pagination | simpleSearch: searchTerm">-->
  <tr *ngFor="let row of pagedItems"
      (click)="onRowClickHandler($event, row)"
      [class.is-selected]="row.selected"
      [class.is-danger]="row.context && row.context === Context.Danger"
      [class.is-warning]="row.context && row.context === Context.Warning"
      [class.is-info]="row.context && row.context === Context.Info"
      [class.is-success]="row.context && row.context === Context.Success"
      [class.has-stripe-danger]="row.stripeContext && row.stripeContext === Context.Danger"
      [class.has-stripe-warning]="row.stripeContext && row.stripeContext === Context.Warning"
      [class.has-stripe-info]="row.stripeContext && row.stripeContext === Context.Info"
      [class.has-stripe-success]="row.stripeContext && row.stripeContext === Context.Success"
      [ngClass]="[row.cssClass? row.cssClass : '']"
      [attr.title]="row.title ? row.title : ''">
    <td *ngFor="let col of columns" class="{{col.cssClass}} tabular__{{col.label}}" [ngClass]="{'tabular__checkboxes': col.dataType === TabularColumnTypes.Checkbox}">

      <!-- checkbox type -->
      <div *ngIf="col.dataType === TabularColumnTypes.Checkbox" class="hx-checkbox-control">
        <input id="checkbox-{{row.id}}" name="{{col.label}}-checkbox" type="checkbox" class="hx-checkbox" title="{{col.label}}" (change)="toggleIndividualSelect($event)" [(ngModel)]="row.checked" />
        <label for="checkbox-{{row.id}}" class="hx-label"></label>
      </div>

      <!-- string type | number type -->
      <span *ngIf="col.dataType === TabularColumnTypes.String || col.dataType === TabularColumnTypes.Number" title="{{row[col.id]}}">{{row[col.id]}}</span>

      <!-- icon type -->
      <i *ngIf="col.dataType === TabularColumnTypes.Icon && hasValidIconTypeParams(row[col.id])" title="" class="hx-icon {{row[col.id].icon}}" [hxTooltip]="row[col.id].tooltip.content" placement="{{row[col.id].tooltip.config.placement}}" [context]="row[col.id].tooltip.config.context"></i>

      <!-- date type -->
      <span *ngIf="col.dataType === TabularColumnTypes.Date">{{row[col.id] | date:'d/M/yy'}}</span>

      <!-- status type -->
      <span *ngIf="col.dataType === TabularColumnTypes.Status" class="hx-icon" [ngClass]="{'is-primary':row[col.id],'is-danger':!row[col.id], 'icon-check-empty': row[col.id], 'icon-close-empty':!row[col.id]}" ></span>

      <!-- badge type -->
      <span *ngIf="col.dataType === TabularColumnTypes.Badge && hasValidBadgeTypeParams(row[col.id])" class="hx-badge is-small {{row[col.id].cssClass}}"><span class="hx-badge-content">{{row[col.id].label}}</span></span>

      <!-- date time type -->
      <span *ngIf="col.dataType === TabularColumnTypes.DateTime">{{row[col.id] | date:'d/M/yy h:mm a'}}</span>

      <!-- actions type -->
      <div *ngIf="col.dataType === TabularColumnTypes.Actions" class="hx-dropdown tabularActions">


        <div class="tabularActions__action">

          <ng-container *ngFor="let action of row[col.id];trackBy: trackByFn">

            <!-- single action -->
            <button type="button" class="hx-button is-flat" [class.is-small]="config.size === TabularSize.Small"
                    *ngIf="!getActionDisabledState(action) && action.routeType === ActionConfigRouteType.Route && !hasChildren(action)"
                    [routerLink]="action.route"
                    class="hx-button is-flat {{action.css}}"
                    title="{{action.label}}"><span class="hx-icon {{action.icon}}"></span></button>
            <button type="button" class="hx-button is-flat" [class.is-small]="config.size === TabularSize.Small"
                    *ngIf="!getActionDisabledState(action) && action.routeType === ActionConfigRouteType.Callback && !hasChildren(action)"
                   (click)='executeCallback($event,action.callback)'
                   class="hx-button is-flat {{action.css}}"><span class="hx-icon {{action.icon}}"></span></button>

            <!-- action with children -->
            <div class="hx-dropdown" hxDropdown [isRight]="true" *ngIf="hasChildren(action)">

              <button class="hx-button is-flat hx-button-dropdown" [class.is-small]="config.size === TabularSize.Small" hxDropdownToggle type="button">
                <i class="icon {{action.icon}}"></i>
              </button>

              <div class="hx-dropdown-menu" *hxDropdownMenu>

                <ng-container *ngFor="let childAction of action.children;trackBy: trackByFn">
                  <a *ngIf="!getActionDisabledState(childAction) && childAction.routeType === ActionConfigRouteType.Route"
                     [routerLink]="childAction.route"
                     class="hx-dropdown-item {{childAction.css}}">{{childAction.label}}</a>
                  <a *ngIf="!getActionDisabledState(childAction) && childAction.routeType === ActionConfigRouteType.Callback"
                     (click)='executeCallback($event,childAction.callback)'
                     class="hx-dropdown-item {{childAction.css}}">{{childAction.label}}</a>
                </ng-container>

              </div>

            </div>

          </ng-container>

        </div>
      </div>

    </td>
  </tr>
  </tbody>
</table>

<hx-pagination [directionLinks]="true" [boundaryLinks]="true" [rotate]="false" [maxSize]="10"
               [totalItems]="totalItemCount" [itemsPerPage]="config.pagination.itemsPerPage"
               [(ngModel)]="config.pagination.currentPage" (pageChanged)="setPage($event)" *ngIf="totalItemCount > config.pagination.itemsPerPage"></hx-pagination>
`,
  styles: [
    '.tabular__sortable {}',
    '.tabular__sorter {cursor:pointer; display:flex; align-items: center;}',
    '.tabular__sorter .hx-icon {margin-left:.1rem;}',
    '.tabular__checkboxes{width:2%;}',
    '.tabular__checkboxes .hx-checkbox-control{display:flex;}',
    '.tabularActions__action button.hx-button{ width: 1rem;}',
    '.tabularActions__action {display:flex;}'
  ]
})


export class TabularComponent implements OnInit, DoCheck {

  /**
   * Collection of column models
   */
  @Input() columns: TabularColumn[];

  /**
   * Collection of data rows
   */
  // todo - this is not strict. should it be when it's dynamic?.
   @Input() rows: ITabularRow[];

  /**
   * Tabular configuration
   * IPaginationInstance, ISearchConfig
   */
  @Input()
  public get config(): ITabularConfig  {
    return this._config;
  }
  public set config(c: ITabularConfig)  {
    if (!c.sortBy) {
      c.sortBy = [];
    }
    this._config = c;
  }

  /** The function to call when a action item is clicked **/
  @Input()
  public get callback(): Function{
    return this._callback;
  }
  public set callback(Fn: Function){
    this._callback = Fn;
  }


  /**
   * Search term is used in the simple search pipe
   * Array of objects: *ngFor="#row of rows | simpleSearch : 'the search term'"
   */
  @Input()
  public get searchTerm(): string{
    return this._searchTerm;
  }
  public set searchTerm(term: string){
    this._searchTerm = term;
  }

  /**
   * Event fired when refresh is called.
   * Host should refresh data of input.
   */
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * Event fired when a row is clicked.
   */
  @Output() rowClick: EventEmitter<any> = new EventEmitter<any>();

  public oldRows: ITabularRow[] = [];
  public pagedItems: any[] = [];
  public TabularColumnTypes = TabularColumnTypes;
  public TabularSize = TabularSize;
  public ActionConfigRouteType = ActionConfigRouteType;
  public selectAll = false;
  public Context = Context;
  public SortByDirection = SortByDirection;
  protected _callback: Function;
  protected _config: ITabularConfig;
  protected _searchTerm: string;


   constructor(
    private conf: TabularConfig,
    private sortByService: TabularSortByService
  ) {
    Object.assign(this, conf);
  }

  ngOnInit() {

  }

  ngDoCheck() {
    if (!_.isEqual(this.rows, this.oldRows)) {
      this.oldRows = _.cloneDeep(this.rows);
      this.orderByData();
    }
  }

  /**
   * Calls the parsed callback with optional arguments
   */
   executeCallback(event: Event, cb: any[]) {
    event.stopPropagation();
    if (cb.length) {
      if (cb.length === 1) { // if callback has no arguments
        cb[0]();
      } else { // if callback has 1 or more arguments
        const args: any[] = [];
        for (let i = 1; i < cb.length; i++) {
          args.push(cb[i]);
        }
        cb[0].apply(this, args);
      }
    }
  }


   toggleSelectAll = ($event) => {
    for (let i = 0; i < this.rows.length; i++) {
      this.rows[i].checked = this.selectAll;
    }
  }


   toggleIndividualSelect = ($event) => {
    let count = 0;
    for (let i = 0; i < this.rows.length; i++) {
      if (this.rows[i].checked) {
        count++;
      }
    }
    this.selectAll = (this.rows.length === count);
  }


  setPage($event: {page: number, itemsPerPage: number} = {
    page: this.config.pagination.currentPage,
    itemsPerPage: this.config.pagination.itemsPerPage
  }) {
    this.config.pagination.currentPage = $event.page;

    // calculate start and end page item indexes
    const startIndex: number = (this.config.pagination.currentPage - 1) * this.config.pagination.itemsPerPage;
    const endIndex: number = Math.min(startIndex + this.config.pagination.itemsPerPage - 1, this.totalItemCount - 1);

    this.pagedItems = this.rows.slice(startIndex, endIndex + 1);
  }


  /**
   * Get the action tooltip if it exists
   */
  getActionTooltip(action: IActionsConfig): string {
    return (action && action.disabledConfig) ? action.disabledConfig.tooltip : '';
  }


  getActionDisabledState(action: IActionsConfig): boolean {
    return (action && action.disabledConfig) ? action.disabledConfig.disabled : false;
  }


  /**
   * Handles the column header click event for sorting.
   * Sort order is Descending, Ascending followed by None.
   */
  onSortClickHandler(key: string, type: TabularColumnTypes) {

    const findPropInSortList = this.config.sortBy.filter((prop: ISortByProperty) => { return (prop.property === key); });

    if (findPropInSortList.length) {
      const prop = findPropInSortList[0];
      const index = this.config.sortBy.findIndex(x => x === prop);
      if (prop.direction === SortByDirection.None) {
        prop.direction = SortByDirection.Descending;
      } else if (prop.direction === SortByDirection.Descending) {
        prop.direction = SortByDirection.Ascending;
      }  else if (prop.direction === SortByDirection.Ascending) {
        if (index > -1) {
          this.config.sortBy.splice(index, 1);
        }
      }
    } else {
      this.config.sortBy.push({property: key, direction: SortByDirection.Descending, type: type});
    }

    this.orderByData();
    return false;
  }


  isColumnSorted(key: string, direction: SortByDirection): boolean {
    const findPropInSortList = this.config.sortBy.filter((prop: ISortByProperty) => { return (prop.property === key && prop.direction === direction); });
    return (findPropInSortList.length > 0);
  }


  /**
   * Handles the row click event.
   */
  onRowClickHandler($event: any, data: any) {
    const el: Element = $event.target;
    if (this.config.clickableRows) {
      if (el.parentElement.tagName === 'BUTTON' ||
          el.tagName === 'BUTTON' ||
          el.parentElement.classList.contains('hx-checkbox-control')) {
        return;
      }
      this.rowClick.emit(data);
    }
  }

  private orderByData() {
    if (this.config.sortBy.length > 0) {
      this.rows = [...this.rows]; // Required as array-sort-by mutates the original array
      this.sortByService.sortBy(this.rows, this.config.sortBy);
    }
    this.setPage();
  }


  get totalItemCount(): number{
    return this.rows.length;
  }


  /**
   * Helper to determine if tabular instance is in small mode
   */
  isSmall(): boolean {
    return (this.config.size === TabularSize.Small);
  }


  hasValidBadgeTypeParams(colData: ITabularColumnBadgeType) {
    if (colData) {
      if (typeof colData.label !== 'undefined') {
        return true;
      } else {
        console.error('Record for column type badge is invalid, make sure you have the right type. ITabularColumnTypeBadge', {columnValue: colData});
      }
    }
    return false;
  }

  hasValidIconTypeParams(colData: ITabularColumnIconType) {
    let hasError = false;
    if (colData) {
      if (typeof colData.icon !== 'undefined') {
        if (typeof colData.tooltip.config !== 'undefined' && typeof colData.tooltip.content !== 'undefined') {
          if (typeof colData.tooltip.config.context !== 'undefined' || typeof colData.tooltip.config.placement !== 'undefined') {
              return true;
          } else {
            hasError = true;
          }
        } else {
          hasError = true;
        }
      } else {
        hasError = true;
      }
    }

    if (hasError) {
      console.error('Record for column type icon is invalid, make sure you have the right type. ITabularColumnTypeIcon', {columnValue: colData});
    }

    return false;
  }

  getTooltipContext(colData: ITabularColumnIconType): Context {
    return (!this.hasValidIconTypeParams(colData)) ? colData.tooltip.config.context : Context.None;
  }



  hasChildren(action: IActionsConfig): boolean {
    return (action.children && action.children.length > 0);
  }

  trackByFn(index, action) {
    return index; // or action.id
  }

}
